import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { PageHeader, Screen } from '@/shared/ui/Layout'

import { ColdStartInvite } from './ColdStartInvite'
import {
  JourneySuggestionCard,
  ProgrammingSuggestionCard
} from './ContentSuggestionCard'
import { HighlightsFallback } from './HighlightsFallback'
import { PartnerSuggestionCard } from './PartnerSuggestionCard'
import { PersonSuggestionCard } from './PersonSuggestionCard'
import { SuggestionSection } from './SuggestionSection'
import { useMatchmakingSuggestionsQuery } from '../model/queries'
import { hasNoSuggestions } from '../model/selectTopSuggestions'

const SkeletonList = () => (
  <div className="grid gap-3" aria-hidden>
    {[0, 1, 2].map(i => (
      <div key={i} className="h-24 animate-pulse rounded-[0.875rem] bg-accent" />
    ))}
  </div>
)

export const MatchmakingPage = () => {
  const { digitalProductId } = useDigitalProductContext()
  const { data, isLoading, isError } = useMatchmakingSuggestionsQuery(digitalProductId)

  const groups = data?.groups
  const isEmpty = hasNoSuggestions(groups)

  return (
    <Screen>
      <Screen.Context>
        <PageHeader title="Conexões" />
      </Screen.Context>

      <Screen.Content>
        {isLoading && <SkeletonList />}

        {isError && (
          <p role="alert" className="text-sm text-gray-700">
            Não conseguimos carregar suas sugestões agora. Tente de novo em
            instantes.
          </p>
        )}

        {data?.cold_start && <ColdStartInvite />}

        {data && !data.cold_start && isEmpty && (
          <HighlightsFallback digitalProductId={digitalProductId} />
        )}

        {groups && !data.cold_start && !isEmpty && (
          <>
            <SuggestionSection
              title="Pessoas"
              subtitle="interesses em comum"
              isEmpty={groups.people.length === 0}
            >
              {groups.people.map(suggestion => (
                <PersonSuggestionCard
                  key={suggestion.record.id}
                  suggestion={suggestion}
                />
              ))}
            </SuggestionSection>

            <SuggestionSection
              title="Empresas"
              isEmpty={groups.partners.length === 0}
            >
              {groups.partners.map(suggestion => (
                <PartnerSuggestionCard
                  key={suggestion.record.id}
                  suggestion={suggestion}
                />
              ))}
            </SuggestionSection>

            <SuggestionSection
              title="Palestras"
              isEmpty={groups.programmings.length === 0}
            >
              {groups.programmings.map(suggestion => (
                <ProgrammingSuggestionCard
                  key={suggestion.record.id}
                  suggestion={suggestion}
                />
              ))}
            </SuggestionSection>

            <SuggestionSection
              title="Trilhas"
              isEmpty={groups.journeys.length === 0}
            >
              {groups.journeys.map(suggestion => (
                <JourneySuggestionCard
                  key={suggestion.record.id}
                  suggestion={suggestion}
                />
              ))}
            </SuggestionSection>
          </>
        )}
      </Screen.Content>
    </Screen>
  )
}
